import React from 'react';
export function PainPointsSection() {
  const painPoints = ['Buscás material de Lengua y Literatura… y encontrás contenidos genéricos que no se adaptan a secundaria', 'Tenés que armar actividades y clases desde cero porque no existe material completo y organizado', 'Tus alumnos no se enganchan con la materia porque todo se vuelve teórico', 'Las planificaciones, textos y evaluaciones te consumen horas que no tenés', 'Querés dar clases más dinámicas y claras… pero no tenés el material estructurado'];
  return <section className="py-5 sm:py-14 bg-transparent border-t border-gray-800" data-id="element-159">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-160">
        <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-white text-center mb-4 sm:mb-8" data-id="element-161">
          <span className="text-red-500 mr-1" data-id="element-162">❌</span> ¿Te pasa esto?
        </h2>

        <div className="space-y-2.5 sm:space-y-4" data-id="element-163">
          {painPoints.map((point, index) => <div key={index} className="bg-[#1a1525] border border-red-900/30 rounded-xl p-3 sm:p-4 flex items-start gap-3" data-id="element-164">
              <span className="text-red-500 text-base sm:text-lg flex-shrink-0 mt-0.5" data-id="element-165">
                ❌
              </span>
              <p className="text-sm sm:text-base text-gray-200 font-medium leading-relaxed" data-id="element-166">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}